import * as types from '../mutation-types'
import approvalService from '../services/approvals'
import Vue from 'vue'

// state
export const state = {
  approvalRequests: [],
  error: false,
  isLoading: false,
  errors: [],
  approvalCount: 0,
  approvalRequest: {},
  responseMessage: ''
}

// getters
export const getters = {
  approvalRequests: state => state.approvalRequests,
  getErrors: state => state.errors,
  approvalRequestsCount: state => state.approvalCount,
  approvalRequest: state => state.approvalRequest,
  responseMessage: state => state.responseMessage,
}

// mutation
export const mutations = {
  [types.FETCH_APPROVAL_REQUESTS_FAILURE] (state) {
    state.isLoading = false
    state.error = true
  },
  [types.SET_APPROVAL_REQUESTS] (state, requests) {
    state.approvalRequests = requests
  },
  [types.UPDATE_APPROVAL_REQUEST_STATUS] (state, payload) {
    const ids = payload.ids
    const status = payload.status
    if (state.approvalRequests && Array.isArray(state.approvalRequests.data)) {
      state.approvalRequests.data.forEach(request => {
        if (ids.includes(request.id)) {
          request.status = status
        }
      })
    }
  },
  REMOVE_APPROVAL_REQUEST (state, payload) {
    const ids = payload.requests.map(request => request.id)

    if (state.approvalRequests && Array.isArray(state.approvalRequests.data)) {
      state.approvalRequests.data = state.approvalRequests.data.filter(req => !ids.includes(req.id))
    }
  },
  SET_PROCESSING (state, isProcessing) {
    state.isProcessing = isProcessing
  },
  SET_APPROVAL_RESPONSE (state, response) {
    state.approvalResponse = response
  },
  [types.SET_ERROR_STATE] (state, payload) {
    state.errors = []
    const errors = []
    const status = payload.response?.status
    if (status === 422) {
      for (const key in payload.response?.data?.errors) {
        errors.push(payload.response?.data?.errors[key][0])
      }
    } else if (status === 400 || status === 401) {
      errors.push(payload.response?.data?.message)
    } else if (status === 404) {
      errors.push(payload.response?.data?.message || 'Approval request not found or no longer valid.')
    } else if (status === 500) {
      errors.push(payload.response?.data?.message || 'Something went wrong while loading this approval request.')
    }
    state.errors = [...errors]
  },
  [types.SET_APPROVAL_COUNT] (state, count) {
    state.approvalCount = count
  },
  [types.SET_APPROVAL_REQUEST] (state, data) {
    state.approvalRequest = data
  },
  [types.SET_RESPONSE_MSG] (state, message) {
    state.responseMessage = message
  }
}

// actions
export const actions = {
  async getApprovalRequests ({ commit }, payload) {
    let searchText = []
    let sortColumn = ''
    let order = ''
    let page = 1
    let rows = 50

    if (payload && payload.data) {
      searchText = payload.data.search || []
      page = payload.data.page || 1
      rows = payload.data.rows || 50
      sortColumn = payload.data.sortColumn || ''
      order = payload.data.order === 'asc' ? 'ASC' : 'DESC'
    }

    try {
      const response = await approvalService.getAllApprovalRequests(searchText, page, rows, sortColumn, order)
      commit('SET_APPROVAL_REQUESTS', response.data)
    } catch (error) {
      commit(types.FETCH_APPROVAL_REQUESTS_FAILURE, error.message)
    }
  },

  async getApprovalRequest ({ commit }, id) {
    try {
      const response = await approvalService.getApprovalRequest(id)
      const approvalRequest = response.data?.data
      if (!approvalRequest) {
        commit(types.SET_APPROVAL_REQUEST, {})
        return null
      }
      try {
        approvalRequest.payload = typeof approvalRequest.payload === 'string'
          ? JSON.parse(approvalRequest.payload || '{}')
          : (approvalRequest.payload || {})
      } catch (parseError) {
        approvalRequest.payload = {}
      }
      commit(types.SET_APPROVAL_REQUEST, approvalRequest)
      return approvalRequest
    } catch (error) {
      commit(types.SET_ERROR_STATE, error)
      commit(types.FETCH_APPROVAL_REQUESTS_FAILURE, error.message)
      return null
    }
  },
  async updateApprovalRequestStatus({ commit }, payload) {
        const { data } = await approvalService.updateApprovalStatus(payload);
        
        const failed_requests = data.data.failed_requests
        const updated_requests = data.data.updated_requests

        if (updated_requests && updated_requests.length > 0) {
            commit('SET_RESPONSE_MSG', data.message);
            commit('UPDATE_APPROVAL_REQUEST_STATUS', {ids: updated_requests, status: payload.status});
        }else{
          commit('SET_RESPONSE_MSG', '');
        }
        if (failed_requests.length > 0) {
          console.log(failed_requests.length, 'failed request ');
          
            failed_requests.forEach(request => {
                Vue.$toast.error(`Request type "${request.type}" failed: ${request.error}`);
            });
        }
        
  },
  async approveApprovalRequest ({ dispatch }, payload) {
    payload.status = 'approved'
    await dispatch('updateApprovalRequestStatus', payload)
  },
  async declineApprovalRequest ({ dispatch }, payload) {
    payload.status = 'declined'
    await dispatch('updateApprovalRequestStatus', payload)
  },
  async deleteApprovalRequest ({ commit, dispatch }, payload) {
    try {
      const {data: data}= await approvalService.deleteApprovalRequests(payload)
      commit('SET_RESPONSE_MSG', data.message)
      commit('REMOVE_APPROVAL_REQUEST', payload)
      await dispatch('getApprovalsCount')
    } catch (error) {
      console.error('Error deleting approval request:', error)
    }
  },
  async processApprovalRequest ({ commit, dispatch }, { requestType, requestId, action, payload }) {
    try {
      payload.request_type = requestType
      payload.request_id = requestId
      payload.action = action

      const response = await approvalService.processApprovalRequest(payload)
      await dispatch('getApprovalsCount')
      return response
    } catch (error) {
      commit(types.SET_ERROR_STATE, error)
      console.error('Error processing account approval:', error)
      return error
    }
  },
  async getApprovalsCount ({ commit }) {
    try {
      const response = await approvalService.getApprovalsCount()
      commit(types.SET_APPROVAL_COUNT, response.data.count)
    } catch (error) {
      commit(types.SET_ERROR_STATE, error)
      return error
    }
  }
}
